var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogIn = function SvgLogIn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.25C2.98122 2.25 1.75 3.48122 1.75 5L1.75 19C1.75 20.5188 2.98122 21.75 4.5 21.75H13.75C14.1642 21.75 14.5 21.4142 14.5 21C14.5 20.5858 14.1642 20.25 13.75 20.25H4.5C3.80964 20.25 3.25 19.6904 3.25 19V5C3.25 4.30965 3.80964 3.75 4.5 3.75L13.75 3.75C14.1642 3.75 14.5 3.41421 14.5 3C14.5 2.58579 14.1642 2.25 13.75 2.25L4.5 2.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0303 7.96967C18.7374 7.67678 18.2626 7.67678 17.9697 7.96967C17.6768 8.26256 17.6768 8.73744 17.9697 9.03033L20.1893 11.25H10.5C10.0858 11.25 9.75 11.5858 9.75 12C9.75 12.4142 10.0858 12.75 10.5 12.75H20.1893L17.9697 14.9697C17.6768 15.2626 17.6768 15.7374 17.9697 16.0303C18.2626 16.3232 18.7374 16.3232 19.0303 16.0303L22.5303 12.5303C22.8232 12.2374 22.8232 11.7626 22.5303 11.4697L19.0303 7.96967Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "log-in.f1f89dad00a4f844e0db5e4fdaef7985.svg";